<!-- New Mobile Menu -->
<div data-menu="mobileMenu" class="side-menu2">
  <div class="menu-btns">
    <!-- <a href="#" class="popup-search" data-popup="1"><i class="fa fa-search"></i></a> -->
    <button id="mobileCloseBtn2" class="close-btn"></button>
  </div>
  <ul>
    <li><a href="/home">Home</a></li>
    <li>
      <a href="javascript:void(0)">Company</a>
      <ul>
        <li><a href="/company/about-us">About us</a></li>
        <li><a href="/company/founder">Founder</a></li>
        <li><a href="/company/team">Team</a></li>
        <li><a href="/company/tech-novelties">Tech Novelties</a></li>
      </ul>
    </li>
    <li>
      <a href="javascript:void(0)" routerLink="/solutions/main"> <span class="menu-item">Solutions</span></a>
      <ul class="sub-menu">
        <li><a href="/solutions/companion">Bessel Companion</a></li>
        <li><a href="/solutions/assistant">Bessel Assistant</a></li>
        <li>
          <a href="javascript:void(0)">Bessel Analytics Plugin</a>
          <ul class="sub-menu v1">
            <li><a href="/solutions/plugins/zoom">Zoom</a></li>
            <li><a href="/solutions/plugins/google-meet">Google Meet</a></li>
            <li><a href="/solutions/plugins/teams">Microsoft Teams</a></li>
            <li><a href="/solutions/plugins/webex">Cisco Webex</a></li>
            <li><a href="/solutions/plugins/zoho-meetings">Zoho Meetings</a></li>
          </ul>
        </li>
      </ul>
    </li>
    <li><a href="/contact">Contact Us</a></li>
  </ul>

</div>
<!-- Overlay for Mobile Menu -->
<div class="overlay2"></div>

<!-- sticky header -->
<header class="sticky-active">
  <div class="header-menu-area">
    <div class="row gx-20 align-items-center justify-content-between">
      <div class="col-auto">
        <div class="header-logo">
          <a href="/home">
            <img [src]="isDarkMode 
    ? 'assets/images/Bessel Footer.png' 
    : 'assets/images/Bessel White Clear.png'" class="logo">
          </a>

        </div>
      </div>
      <div class="col-auto">
        <nav class="main-menu menu-style1">
          <ul>
            <li>
              <a href="javascript:void(0)" routerLink="/home" class="active">
                <span class="menu-item">Home</span>
                <span class="menu-item2">Home</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <span class="menu-item">Company</span>
                <span class="menu-item2">Company</span>
              </a>
              <ul class="sub-menu">
                <li><a routerLink="/company/about-us">About Us</a></li>
                <li><a routerLink="/company/founder">Founder</a></li>
                <li><a routerLink="/company/team">Team</a></li>
                <li><a routerLink="/company/tech-novelties"> Tech Novelties</a></li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0)" routerLink="/solutions/main">
                <span class="menu-item">Solutions</span>
                <span class="menu-item2">Solutions</span>
              </a>
              <ul class="sub-menu">
                <li><a routerLink="/solutions/companion">Bessel Companion</a></li>
                <li><a routerLink="/solutions/assistant">Bessel Assistant</a></li>
                <li>
                  <a href="javascript:void(0)">Bessel Analytics Plugin</a>
                  <ul class="sub-menu v1">
                    <li><a routerLink="/solutions/plugins/zoom">Zoom</a></li>
                    <li><a routerLink="/solutions/plugins/google-meet">Google Meet</a></li>
                    <li><a routerLink="/solutions/plugins/teams">Microsoft Teams</a></li>
                    <li><a routerLink="/solutions/plugins/webex">Cisco Webex</a></li>
                    <li><a routerLink="/solutions/plugins/zoho-meetings">Zoho Meetings</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <a href="javascript:void(0)" routerLink="/contact">
                <span class="menu-item">Contact Us</span>
                <span class="menu-item2">Contact Us</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-auto d-none d-xl-block">
        <div class="btn-box">
          <!-- <a href="#" class="popup-search" data-popup="1"><i class="fa fa-search"></i></a>
          <a href="contact.html" title="" class="ibt-btn ibt-btn-outline-3 ibt-btn-rounded">
            <span>Get in Touch</span>
          </a> -->
        </div>
      </div>
    </div>
    <button class="hamburger popup-menu" data-menu="mobileMenu">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</header>
<!-- End sticky header -->

<!--======== Header ========-->
<header class="vs-header5">
  <div class="container2 position-relative">
    <div class="header-menu-area5">
      <div class="row gx-20 align-items-center justify-content-between">
        <div class="col-auto">
          <div class="header-logo">
            <!-- <a href="javascript:void(0)" class="menu-toggle"></a> -->
            <a href="/home">
              <img src="assets/images/Bessel Footer.png" class="logo" *ngIf="isDarkMode">

              <img src="assets/images/Bessel White Clear.png" class="logo" *ngIf="!isDarkMode">
            </a>
          </div>
        </div>
        <div class="col-auto">
          <nav class="main-menu menu-style1">
            <ul>
              <li>
                <a routerLink="/home" class="active">
                  <span class="menu-item">Home</span>
                  <span class="menu-item2">Home</span>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)">
                  <span class="menu-item">Company</span>
                  <span class="menu-item2">Company</span>
                </a>
                <ul class="sub-menu">
                  <li><a routerLink="/company/about-us">About Us</a></li>
                  <li><a routerLink="/company/founder">Founder</a></li>
                  <li><a routerLink="/company/team">Team</a></li>
                  <li><a routerLink="/company/tech-novelties"> Tech Novelties</a></li>
                </ul>
              </li>
              <li>
                <a href="javascript:void(0)" routerLink="/solutions/main">
                  <span class="menu-item">Solutions</span>
                  <span class="menu-item2">Solutions</span>
                </a>
                <ul class="sub-menu">
                  <li><a routerLink="/solutions/companion">Bessel Companion</a></li>
                  <li><a routerLink="/solutions/assistant">Bessel Assistant</a></li>
                  <li>
                    <a href="javascript:void(0)">Bessel Analytics Plugin</a>
                    <ul class="sub-menu v1">
                      <li><a routerLink="/solutions/plugins/zoom">Zoom</a></li>
                      <li><a routerLink="/solutions/plugins/google-meet">Google Meet</a></li>
                      <li><a routerLink="/solutions/plugins/teams">Microsoft Teams</a></li>
                      <li><a routerLink="/solutions/plugins/webex">Cisco Webex</a></li>
                      <li><a routerLink="/solutions/plugins/zoho-meetings">Zoho Meetings</a></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <a routerLink="/contact">
                  <span class="menu-item">Contact Us</span>
                  <span class="menu-item2">Contact Us</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-auto d-none d-xl-block">
          <div class="btn-box">
            <!-- <a href="#" class="popup-search" data-popup="1"><i class="fa fa-search"></i></a>
            <a href="contact.html" title="" class="ibt-btn ibt-btn-outline-3 ibt-btn-rounded">
              <span>Get in Touch</span>
            </a> -->
          </div>
        </div>
      </div>
      <button class="hamburger popup-menu" data-menu="mobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </div>
</header>
<button id="themeBtn" (click)="toggleTheme()" [class.active-btn]="isDarkMode">

  <i [class.far]="!isDarkMode" [class.fas]="isDarkMode" [class.fa-moon]="!isDarkMode" [class.fa-sun]="isDarkMode">
  </i>

</button>
<!--======== / Header ========-->